import React from "react";
import { Box, Typography } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import "@fontsource/prompt"; // Import Prompt font

const TKSMemberCard = ({ member }) => {
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: 600,
                mx: 'auto',
                overflow: "hidden",
                fontFamily: "Prompt, sans-serif", // ✅ Use Prompt font
                boxShadow: 3,
                background: "linear-gradient(to bottom right, #fff2cc, #fff9e9)",
                position: "relative",
            }}
        >
            {/* Top Header with curve */}
            <Box
                sx={{
                    position: "relative",
                    background: "linear-gradient(to right, #fceabb, #f8b500)",
                    height: 80,
                    display: "flex",
                    alignItems: "center",
                    px: 2,
                }}
            >
                <img
                    src="/CWA_logo.png"
                    alt="Logo"
                    style={{ height: 55, width: "auto" }}
                />
                <Typography
                    variant="h6"
                    sx={{
                        flex: 1,
                        textAlign: "center",
                        fontWeight: 600,
                        color: "red",
                        fontFamily: "Prompt, sans-serif",
                        fontSize: 18
                    }}
                >
                    திருக்கடையூர் சேனைத்தலைவர் அறக்கட்டளை
                </Typography>
            </Box>

            {/* Direct Content on background */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    alignItems: "center",
                    px: 4,
                    py: 5,
                    gap: 2,
                }}
            >
                <Box sx={{ textAlign: "left", flex: 1 }}>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        NAME : {member.First_Name} {member.Last_Name}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        MEMBER ID : {member.id}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        DISTRICT : {member.District}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        LOCATION : {member.City}
                    </Typography>
                </Box>

                <Box sx={{ ml: 2, flexShrink: 0 }}>
                    <QRCodeCanvas
                        value={`TKS Member ID: ${member.id}\nName: ${member.First_Name} ${member.Last_Name}\nDistrict: ${member.District}\nLocation: ${member.City}\nMobile Number: ${member.Mobile_Number}`}
                        size={110}
                        bgColor="transparent"
                        fgColor="#000000"
                        level="L"
                        marginSize={-9}
                        imageSettings={{
                            src: "/CWA_logo.png",
                            height: 20,
                            width: 20,
                            opacity: 1.1,
                            excavate: true,
                        }}
                    />
                </Box>
            </Box>

            {/* Bottom bar with shallow notch */}
            <Box
                sx={{
                    height: 70,
                    background: "linear-gradient(to right, #e21818, #ffe600)",
                    borderBottomRightRadius: "8px",
                    boxShadow: "0 6px 8px rgba(0, 0, 0, 0.1)",
                }}
            />
        </Box>
    );
};

export default TKSMemberCard;
